import { useState } from 'react'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import {
  SUBMENU_PARAM_ACTIVE_VALUE,
  SUBMENU_PARAM_KEY,
} from '../../../../../constants/route'
import { useQueryParamSubTab } from '../../../../../hooks'
import { getSubSearchParam } from '../../../../../utils/route'
import {
  getSubMenuDefaultItemName,
  getSubMenuItemNames,
} from '../../../../SubMenu'

export function useEntityTabSubMenuSubTab({
  defaultValue = SUBMENU_PARAM_ACTIVE_VALUE,
  isUrlBound,
} = EMPTY_OBJECT) {
  const [subMenu, setSubMenu] = useState(null)

  const { activeSubTab, setActiveSubTab } = useQueryParamSubTab({
    allowedValues: subMenu ? getSubMenuItemNames(subMenu) : null,
    defaultValue: subMenu ? getSubMenuDefaultItemName(subMenu) : defaultValue,
    isUrlBound,
    paramKey: SUBMENU_PARAM_KEY,
    readValue: getSubSearchParam,
  })

  return { activeSubTab, setActiveSubTab, setSubMenu, subMenu }
}
